import React, { useEffect, useState } from 'react';
import { applyTheme, persistTheme, readStoredTheme } from '../services/theme';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => readStoredTheme());

  useEffect(() => {
    applyTheme(theme);
    persistTheme(theme);
  }, [theme]);

  const nextTheme = theme === 'dark' ? 'light' : 'dark';
  const label = theme === 'dark' ? 'Ativar modo claro' : 'Ativar modo escuro';

  return (
    <button
      type="button"
      className="navbar-theme-toggle"
      onClick={() => setTheme(nextTheme)}
      aria-label={label}
      title={label}
      aria-pressed={theme === 'light'}
    >
      <i className={`fas ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`} aria-hidden="true"></i>
      <span>{theme === 'dark' ? 'Claro' : 'Escuro'}</span>
    </button>
  );
}
